import { render, staticRenderFns } from "./MenuInformacao.vue?vue&type=template&id=07a1837a"
import script from "./MenuInformacao.vue?vue&type=script&lang=js"
export * from "./MenuInformacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports